import { Injectable } from '@angular/core';

export enum SwipeDirection {
  None,
  Left,
  Right,
  Up,
  Down
}

@Injectable({
  providedIn: 'root'
})
export class SwipeDetectionServiceService {
  private startTime: number;
  private startX: number;
  private startY: number;
  private threshold = 50; // 80; // required travel distance to count as swipe
  private allowedTime = 300; // maximum required time to count as swipe

  /**
   * touch gesture controll.
   * Start a new touch with the first finger on the component
   */
  start(e: TouchEvent, scrollable = true) {
    const touchobj = e.changedTouches[0];
    this.startX = touchobj.pageX;
    this.startY = touchobj.pageY;
    this.startTime = new Date().getTime();
    if (!scrollable) {
      e.preventDefault();
    }
  }

  /**
   * I'm currently just here to prevent scrolling while swiping.
   * Update me to trigger swipe 'while' swiping
   * @param e TouchEvent
   */
  move(e: TouchEvent) {
    e.preventDefault();
  }

  /**
   * finger removed from screen. compare to start to determine direction and co.
   * @param e TouchEvent end of the touch
   */
  end(e: TouchEvent, allowedTime?: number) {
    if (allowedTime) {
      this.allowedTime = allowedTime;
    }
    const touchobj = e.changedTouches[0];
    const distX = touchobj.pageX - this.startX;
    const distY = touchobj.pageY - this.startY;
    const elapsedTime = new Date().getTime() - this.startTime;
    let swipedir: SwipeDirection = SwipeDirection.None;
    if (elapsedTime <= this.allowedTime) {
      // time ok, check direction
      if (Math.abs(distX) >= this.threshold) {
        swipedir = distX < 0 ? SwipeDirection.Left : SwipeDirection.Right;
      } else if (Math.abs(distY) >= this.threshold) {
        swipedir = distY < 0 ? SwipeDirection.Up : SwipeDirection.Down;
      } else {
        swipedir = SwipeDirection.None;
      }
    }

    return swipedir;
  }
}
